import { ReadonlyServiceQueue } from '@modules/ServiceModule/workspace/types/ServiceQueue';
import ServiceUser from '@modules/ServiceModule/workspace/types/ServiceUser';

export const mapQueueIdToUsers = (
  queues: Readonly<ReadonlyServiceQueue[]>,
  userByContactCenterUserId: Readonly<Record<string, ServiceUser>>,
) => {
  const res = queues.reduce((acc: { [key: string]: ServiceUser[] }, queue) => {
    const members = queue.memberIds
      .map((memberId: string | number) => userByContactCenterUserId[memberId])
      .filter(Boolean);
    acc[queue.id] = [...members];
    return acc;
  }, {});

  return res;
};
